export default __webpack_public_path__ + "static/media/modal-proprietarios-pinhais-mkj.e2a68a2d.webp";